export class RoundRobinSelector<T> {
    private items: T[];
    private index: number = 0;

    constructor(items: T[]) {
        if (items.length === 0) {
            throw new Error("Item list cannot be empty");
        }
        this.items = items;
    }

    public getNext(): T {
        const item = this.items[this.index];
        this.index = (this.index + 1) % this.items.length;
        return item;
    }
}
